import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const CreateUserModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: 'student',
    sendEmail: true,
    generateInviteCode: false
  });

  const [errors, setErrors] = useState({});

  const roleOptions = [
    { value: 'student', label: 'Student' },
    { value: 'admin', label: 'Admin' }
  ];

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData?.name?.trim()) {
      newErrors.name = 'Name is required';
    }
    
    if (!formData?.email?.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) {
      newErrors.email = 'Invalid email format';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
      handleClose();
    }
  };

  const handleClose = () => {
    setFormData({
      name: '',
      email: '',
      role: 'student',
      sendEmail: true,
      generateInviteCode: false
    });
    setErrors({});
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-foreground/50 z-40 animate-fade-in"
        onClick={handleClose}
        aria-hidden="true"
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-card border border-border rounded-lg shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto animate-scale-in">
          <div className="flex items-center justify-between p-6 border-b border-border">
            <h2 className="text-xl font-semibold text-card-foreground flex items-center gap-2">
              <Icon name="UserPlus" size={24} />
              Create New User
            </h2>
            <button
              onClick={handleClose}
              className="p-2 rounded-md hover:bg-muted transition-colors duration-150"
              aria-label="Close modal"
            >
              <Icon name="X" size={20} />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            <Input
              label="Full Name"
              type="text"
              placeholder="Enter full name"
              value={formData?.name}
              onChange={(e) => setFormData({ ...formData, name: e?.target?.value })}
              error={errors?.name}
              required
            />

            <Input
              label="Email Address"
              type="email"
              placeholder="user@example.com"
              value={formData?.email}
              onChange={(e) => setFormData({ ...formData, email: e?.target?.value })}
              error={errors?.email}
              required
            />

            <Select
              label="User Role"
              options={roleOptions}
              value={formData?.role}
              onChange={(value) => setFormData({ ...formData, role: value })}
              required
            />

            <div className="space-y-3 pt-2">
              <Checkbox
                label="Send welcome email with login credentials"
                checked={formData?.sendEmail}
                onChange={(e) => setFormData({ ...formData, sendEmail: e?.target?.checked })}
              />

              <Checkbox
                label="Generate invite code for registration"
                description="User will need this code to complete registration"
                checked={formData?.generateInviteCode}
                onChange={(e) => setFormData({ ...formData, generateInviteCode: e?.target?.checked })}
              />
            </div>

            <div className="flex items-center gap-3 pt-4">
              <Button
                type="submit"
                variant="default"
                fullWidth
                iconName="UserPlus"
                iconPosition="left"
              >
                Create User
              </Button>
              <Button
                type="button"
                variant="outline"
                fullWidth
                onClick={handleClose}
              >
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreateUserModal;